<div class="li-dialog">

  <!-- Loading state (questions definitions, then draft fetch on edit) -->
  <div class="li-loading" *ngIf="questionsLoading || loading">
    <mat-spinner diameter="36"></mat-spinner>
  </div>

 
  <div class="li-loading" style="flex-direction: column; gap: 16px;" *ngIf="!questionsLoading && questionsError">
    <p class="li-help" style="margin: 0; text-align: center;">
      Unable to load legal information questions. Please try again.
    </p>
    <button class="li-btn-primary" (click)="retryLoadQuestions()">Retry</button>
  </div>

  <ng-container *ngIf="!loading && !questionsLoading && !questionsError">

    <!-- ===================== WIZARD ===================== -->
    <ng-container *ngIf="mode === 'wizard'">
      <div class="li-header">
        <div>
          <div class="li-step-label">STEP {{ currentStepIndex + 1 }} OF {{ totalSteps }}</div>
          <div class="li-title">Legal Information</div>
        </div>
        <button class="li-close" (click)="cancel()" aria-label="Close">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="li-progress-track">
        <div class="li-progress-fill" [style.width.%]="progressPercent"></div>
      </div>

      <!-- Visually hidden — announces word-limit trims (paste/type/voice)
           for screen reader users; the visible notice piggybacks on the
           existing toast + counter color for sighted users. -->
      <div class="li-sr-only" aria-live="polite">{{ wordLimitNoticeMessage }}</div>

      <div class="li-body">
        <h3 class="li-question">{{ currentQuestion.title }}</h3>
        <div class="li-help-row" [class.li-help-row--events]="currentQuestion.type === 'events'">
          <p class="li-help" *ngIf="currentQuestion.helpText">{{ currentQuestion.helpText }}</p>
          <button class="li-link-btn li-add-event-inline" *ngIf="currentQuestion.type === 'events'"
            (click)="addEvent()">+ Add Event</button>
        </div>

        <ng-container [ngSwitch]="currentQuestion.type">

          <!-- Q1: case title -->
          <ng-container *ngSwitchCase="'text-yesno'">
            <div class="li-radio-row">
              <label class="li-radio">
                <input type="radio" name="q1" [checked]="answers.hasCaseTitle === true" (change)="setHasCaseTitle(true)">
                <span class="li-radio-dot"></span> {{ currentQuestion.yesLabel }}
              </label>
              <label class="li-radio">
                <input type="radio" name="q1" [checked]="answers.hasCaseTitle === false" (change)="setHasCaseTitle(false)">
                <span class="li-radio-dot"></span> {{ currentQuestion.noLabel }}
              </label>
            </div>

            <ng-container *ngIf="answers.hasCaseTitle">
              <label class="li-field-label">Case title</label>
              <div class="li-input-with-mic">
                <input type="text" class="li-input" [ngModel]="answers.caseTitle" (ngModelChange)="setCaseTitle($event)" [appWordLimit]="currentQuestion.wordLimit" (limitTrimmed)="onWordLimitTrimmed($event)" aria-live="polite" [placeholder]="currentQuestion.placeholder">
                <button type="button" class="li-mic-btn" *ngIf="currentQuestion.voiceInput" [class.active]="isListening('caseTitle')"
                  [class.error]="hasVoiceError('caseTitle')"
                  [attr.aria-label]="isListening('caseTitle') ? 'Stop voice input' : 'Start voice input'"
                  [attr.aria-pressed]="isListening('caseTitle')"
                  [title]="isListening('caseTitle') ? 'Listening… tap to stop' : 'Tap to speak'"
                  (click)="toggleVoiceInput('caseTitle')">
                  <span class="li-mic-pulse" *ngIf="isListening('caseTitle')"></span>
                  <mat-icon>{{ isListening('caseTitle') ? 'stop' : 'mic' }}</mat-icon>
                </button>
              </div>
              <div class="li-voice-status" *ngIf="isListening('caseTitle')" aria-live="polite">
                <span class="li-voice-dot"></span> Listening…
              </div>
              <div class="li-voice-status error" *ngIf="hasVoiceError('caseTitle')" aria-live="polite">
                <mat-icon>info</mat-icon> {{ voiceErrorMessage }}
              </div>
              <div class="li-word-count" [class.li-limit-reached]="isAtWordLimit(answers.caseTitle, currentQuestion.wordLimit)">{{ wordCount(answers.caseTitle) }}/{{ currentQuestion.wordLimit }} words</div>
            </ng-container>
          </ng-container>

          <!-- Q2 / Q8: yes/no or radio + multi-select chips (Q9 deadlines handled inline below) -->
          <ng-container *ngSwitchCase="'chips-yesno'">
            <ng-container *ngIf="currentQuestion.step !== 9; else deadlineBlock">
              <div class="li-radio-row">
                <label class="li-radio">
                  <input type="radio" name="cy-{{currentQuestion.step}}"
                    [checked]="getBinaryAnswer(currentQuestion) === true"
                    (change)="setBinaryAnswer(currentQuestion, true)">
                  <span class="li-radio-dot"></span> {{ currentQuestion.yesLabel }}
                </label>
                <label class="li-radio">
                  <input type="radio" name="cy-{{currentQuestion.step}}"
                    [checked]="getBinaryAnswer(currentQuestion) === false"
                    (change)="setBinaryAnswer(currentQuestion, false)">
                  <span class="li-radio-dot"></span> {{ currentQuestion.noLabel }}
                </label>
              </div>

              <ng-container *ngIf="getBinaryAnswer(currentQuestion)">
                <ng-container *ngTemplateOutlet="chipsPicker"></ng-container>
              </ng-container>
            </ng-container>

            <!-- Q9 deadlines gets its own layout -->
            <ng-template #deadlineBlock>
              <div class="li-radio-row">
                <label class="li-radio">
                  <input type="radio" name="q9" [checked]="answers.knowsDeadlines === true" (change)="answers.knowsDeadlines = true">
                  <span class="li-radio-dot"></span> {{ currentQuestion.yesLabel }}
                </label>
                <label class="li-radio">
                  <input type="radio" name="q9" [checked]="answers.knowsDeadlines === false" (change)="answers.knowsDeadlines = false">
                  <span class="li-radio-dot"></span> {{ currentQuestion.noLabel }}
                </label>
              </div>

              <ng-container *ngIf="answers.knowsDeadlines">
                <label class="li-field-label">{{ currentQuestion.optionsFieldLabel }}</label>

                <!-- Deadline types as selectable chips (existing .li-toggle-row/.li-toggle-btn
                     styling already in this stylesheet) instead of the searchable dropdown. -->
                <div class="li-toggle-row">
                  <button type="button" class="li-toggle-btn" *ngFor="let type of deadlineTypes"
                    [class.active]="isDeadlineTypeSelected(type)"
                    [attr.aria-pressed]="isDeadlineTypeSelected(type)"
                    (click)="toggleDeadlineType(type)">
                    {{ type }}
                  </button>
                </div>

                <div class="li-deadline-grid" *ngFor="let type of deadlineTypes">
                  <ng-container *ngIf="isDeadlineTypeSelected(type)">
                    <div class="li-deadline-row">
                      <div>
                        <label class="li-field-label">{{ type }}</label>
                        <div class="li-date-field">
                          <input type="text" class="li-input" readonly placeholder="Select date"
                            [matDatepicker]="deadlinePicker"
                            [ngModel]="dateStringToDate(deadlineFor(type)!.date)"
                            (ngModelChange)="deadlineFor(type)!.date = dateToDateString($event)"
                            (focus)="deadlinePicker.open()" (click)="deadlinePicker.open()">
                          <mat-datepicker-toggle class="li-date-toggle" [for]="deadlinePicker"></mat-datepicker-toggle>
                          <mat-datepicker #deadlinePicker></mat-datepicker>
                        </div>
                      </div>
                      <div>
                        <label class="li-field-label">
                          Notes
                          <span class="li-required" *ngIf="type === 'Other'">*</span>
                          <span class="li-optional" *ngIf="type !== 'Other'">(optional)</span>
                        </label>
                        <input type="text" class="li-input" placeholder="Add notes..." [ngModel]="deadlineFor(type)!.notes" (ngModelChange)="setDeadlineNotes(type, $event)" [appWordLimit]="type === 'Other' ? 50 : 150" aria-live="polite">
                        <div class="li-word-count">
                          {{ wordCount(deadlineFor(type)!.notes || '') }}/{{ type === 'Other' ? 50 : 150 }} words
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </ng-template>
          </ng-container>

          <!-- Q7: radio ("Let me see options" / "I don't know yet") + multi-select chips.
               FIX: the config marks Q7 as type 'chips-radio' but the template had no
               matching case, so Step 7 rendered blank. This mirrors the chips-yesno
               branch but binds the radio to answers.wantsOutcomeOptions (its own key)
               and reuses the shared #chipsPicker template (which resolves its list/other
               text via listAndOtherFor(step) -> expectedOutcomes / expectedOutcomeOther). -->
          <ng-container *ngSwitchCase="'chips-radio'">
            <div class="li-radio-row">
              <label class="li-radio">
                <input type="radio" name="cr-{{currentQuestion.step}}"
                  [checked]="answers.wantsOutcomeOptions === true"
                  (change)="answers.wantsOutcomeOptions = true">
                <span class="li-radio-dot"></span> {{ currentQuestion.yesLabel }}
              </label>
              <label class="li-radio">
                <input type="radio" name="cr-{{currentQuestion.step}}"
                  [checked]="answers.wantsOutcomeOptions === false"
                  (change)="answers.wantsOutcomeOptions = false">
                <span class="li-radio-dot"></span> {{ currentQuestion.noLabel }}
              </label>
            </div>

            <ng-container *ngIf="answers.wantsOutcomeOptions">
              <ng-container *ngTemplateOutlet="chipsPicker"></ng-container>
            </ng-container>
          </ng-container>

          <!-- Q3: opposing parties -->
          <ng-container *ngSwitchCase="'parties'">
            <div class="li-radio-row">
              <label class="li-radio">
                <input type="radio" name="q3" [checked]="answers.knowsOpposingParty === true" (change)="setKnowsOpposingParty(true)">
                <span class="li-radio-dot"></span> {{ currentQuestion.yesLabel }}
              </label>
              <label class="li-radio">
                <input type="radio" name="q3" [checked]="answers.knowsOpposingParty === false" (change)="setKnowsOpposingParty(false)">
                <span class="li-radio-dot"></span> {{ currentQuestion.noLabel }}
              </label>
            </div>

            <ng-container *ngIf="answers.knowsOpposingParty">
              <div class="li-parties-header">
                <span>{{ answers.opposingParties.length }} part{{ answers.opposingParties.length === 1 ? 'y' : 'ies' }} added</span>
                <button class="li-link-btn" (click)="addParty()">+ Add Another Party</button>
              </div>

              <div class="li-party-card" *ngFor="let party of answers.opposingParties; let i = index; let last = last">
                <div class="li-party-card-head">
                  <span>PARTY {{ i + 1 }}</span>
                  <button class="li-icon-btn danger" *ngIf="answers.opposingParties.length > 1" (click)="removeParty(i)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
                <div class="li-grid-3">
                  <div>
                    <label class="li-field-label">Name <span class="li-required">*</span></label>
                    <input type="text" class="li-input" placeholder="Full name" [(ngModel)]="party.name">
                  </div>
                  <div>
  <label class="li-field-label">
    Phone <span class="li-required">*</span>
  </label>

  <input
    type="tel"
    class="li-input"
    placeholder="Enter 10-digit phone number"
    [ngModel]="party.phone"
    (ngModelChange)="setPartyPhone(party, $event)"
    (keydown)="allowOnlyDigits($event)"
    #partyPhoneModel="ngModel"
    maxlength="10"
    inputmode="numeric"
    autocomplete="tel"
  />

  <div
    class="li-field-error"
    *ngIf="(partyPhoneModel.touched || partyValidationAttempted) && !isPartyPhoneValid(party)"
  >
    Please enter a valid 10-digit phone number.
  </div>
</div>
                  <div>
                    <label class="li-field-label">Role / Relationship <span class="li-required">*</span></label>
                    <input type="text" class="li-input" placeholder="e.g. Employer, Builder" [(ngModel)]="party.role">
                  </div>
                </div>
                <div class="li-grid-2">
                  <div>
                    <label class="li-field-label">Email <span class="li-optional">(optional)</span></label>
                    <input type="email" class="li-input" placeholder="email&#64;example.com" [(ngModel)]="party.email" #partyEmailModel="ngModel">
                    <div class="li-field-error" *ngIf="(partyEmailModel.touched || partyValidationAttempted) && party.email && !isPartyEmailValid(party)">Please enter a valid email address.</div>
                  </div>
                  <div>
                    <label class="li-field-label">Address <span class="li-optional">(optional)</span></label>
                    <input type="text" class="li-input" placeholder="Full address" [(ngModel)]="party.address">
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>

          <!-- Q4 / Q10: long text -->
          <ng-container *ngSwitchCase="'textarea'">
            <div class="li-textarea-wrap">
              <textarea class="li-textarea" [placeholder]="currentQuestion.placeholder"
                [ngModel]="textValue(currentQuestion.key)" (ngModelChange)="setTextValue(currentQuestion.key, $event)"
                [appWordLimit]="currentQuestion.wordLimit" (limitTrimmed)="onWordLimitTrimmed($event)"
                rows="8" aria-live="polite"></textarea>
              <button type="button" class="li-mic-btn floating" *ngIf="currentQuestion.voiceInput"
                [class.active]="isListening(currentQuestion.key)"
                [class.error]="hasVoiceError(currentQuestion.key)"
                [attr.aria-label]="isListening(currentQuestion.key) ? 'Stop voice input' : 'Start voice input'"
                [attr.aria-pressed]="isListening(currentQuestion.key)"
                [title]="isListening(currentQuestion.key) ? 'Listening… tap to stop' : 'Tap to speak'"
                (click)="toggleVoiceInput(currentQuestion.key)">
                <span class="li-mic-pulse" *ngIf="isListening(currentQuestion.key)"></span>
                <mat-icon>{{ isListening(currentQuestion.key) ? 'stop' : 'mic' }}</mat-icon>
              </button>
            </div>
            <div class="li-voice-status" *ngIf="isListening(currentQuestion.key)" aria-live="polite">
              <span class="li-voice-dot"></span> Listening…
            </div>
            <div class="li-voice-status error" *ngIf="hasVoiceError(currentQuestion.key)" aria-live="polite">
              <mat-icon>info</mat-icon> {{ voiceErrorMessage }}
            </div>
            <div class="li-word-count" [class.li-limit-reached]="isAtWordLimit(textValue(currentQuestion.key), currentQuestion.wordLimit)">
              {{ wordCount(textValue(currentQuestion.key)) }}/{{ currentQuestion.wordLimit }} words
              <!-- <span *ngIf="currentQuestion.required"> &middot; Required</span> -->
            </div>
          </ng-container>

          <!-- Q5: events -->
          <ng-container *ngSwitchCase="'events'">
            <!-- "+ Add Event" now renders inline with the helper text above (see .li-help-row--events) -->

            <!-- Column order reflects the meaningful entry flow: Date + Time
                 grouped together ("when"), then Event ("what"), then the
                 optional Location ("where"), then the row action. -->
            <div class="li-events-head" *ngIf="answers.events.length">
              <span>Date <span class="li-required">*</span></span>
              <label>Time<span class="li-optional">(optional)</span></label>
              <span>Event <span class="li-required">*</span></span>
              <label>Location<span class="li-optional">(optional)</span></label>
              <span></span>
            </div>

            <div class="li-event-row" *ngFor="let evt of answers.events; let i = index">
              <div class="li-date-field">
                <input type="text" class="li-input" readonly placeholder="Select date"
                  [matDatepicker]="eventPicker"
                  [ngModel]="dateStringToDate(evt.date)"
                  (ngModelChange)="evt.date = dateToDateString($event)"
                  (focus)="eventPicker.open()" (click)="eventPicker.open()">
                <mat-datepicker-toggle class="li-date-toggle" [for]="eventPicker"></mat-datepicker-toggle>
                <mat-datepicker #eventPicker></mat-datepicker>
              </div>

              <!-- Modernized Time picker — replaces the native <input type="time">
                   (whose browser-default popup looked inconsistent with the rest
                   of the UI). Reuses the same fixed-position .li-ms/.li-ms-panel
                   dropdown scaffold as the Document Type combobox below, so it
                   opens/closes/positions itself exactly the same way. The stored
                   value stays the same "HH:mm" 24-hour string the native input
                   used, so nothing downstream (payload/hydration) changes. -->
              <div class="li-ms li-time-ms" [class.open]="isEventTimeDropdownOpen(i)">
                <button type="button" class="li-ms-control li-time-control" role="combobox"
                  [attr.aria-expanded]="isEventTimeDropdownOpen(i)" aria-haspopup="listbox"
                  (click)="toggleEventTimeDropdown(i, $event)">
                  <span class="li-time-control-inner">
                    <mat-icon class="li-time-clock-icon">schedule</mat-icon>
                    <span class="li-ms-summary" *ngIf="evt.time">{{ formatEventTimeDisplay(evt.time) }}</span>
                    <span class="li-ms-placeholder" *ngIf="!evt.time">Select time</span>
                  </span>
                  <mat-icon class="li-ms-caret">expand_more</mat-icon>
                </button>

                <div class="li-ms-panel li-time-panel" [class.upward]="msOpenUpward" [ngStyle]="msPanelStyle" *ngIf="isEventTimeDropdownOpen(i)">
                  <div class="li-time-columns">
                    <div class="li-time-col">
                      <div class="li-time-col-label">Hour</div>
                      <div class="li-time-col-scroll" role="listbox" aria-label="Hour">
                        <button type="button" class="li-time-option" *ngFor="let h of eventTimeHours"
                          role="option" [attr.aria-selected]="hour12FromEventTime(evt.time) === h"
                          [class.selected]="hour12FromEventTime(evt.time) === h"
                          (click)="selectEventHour(evt, h)">{{ h }}</button>
                      </div>
                    </div>
                    <div class="li-time-col">
                      <div class="li-time-col-label">Min</div>
                      <div class="li-time-col-scroll" role="listbox" aria-label="Minute">
                        <button type="button" class="li-time-option" *ngFor="let m of eventTimeMinutes"
                          role="option" [attr.aria-selected]="minuteFromEventTime(evt.time) === m"
                          [class.selected]="minuteFromEventTime(evt.time) === m"
                          (click)="selectEventMinute(evt, m)">{{ padTwo(m) }}</button>
                      </div>
                    </div>
                    <div class="li-time-col li-time-col-period">
                      <div class="li-time-col-label">&nbsp;</div>
                      <div class="li-time-col-scroll" role="listbox" aria-label="AM or PM">
                        <button type="button" class="li-time-option" *ngFor="let p of eventTimePeriods"
                          role="option" [attr.aria-selected]="periodFromEventTime(evt.time) === p"
                          [class.selected]="periodFromEventTime(evt.time) === p"
                          (click)="selectEventPeriod(evt, p)">{{ p }}</button>
                      </div>
                    </div>
                  </div>
                  <div class="li-time-footer">
                    <button type="button" class="li-link-btn" (click)="clearEventTime(evt)">Clear</button>
                    <button type="button" class="li-time-done-btn" (click)="closeEventTimeDropdown()">Done</button>
                  </div>
                </div>
              </div>

              <div>
                <input type="text" class="li-input" placeholder="Event" [ngModel]="evt.event" (ngModelChange)="setEventText(evt, $event)" [appWordLimit]="50" aria-live="polite">
                <div class="li-word-count" [class.li-required]="!isEventTextValid(evt)">
                  {{ wordCount(evt.event) }}/50 words
                </div>
              </div>
              <input type="text" class="li-input" placeholder="Location" [(ngModel)]="evt.location">
              <button class="li-icon-btn danger" (click)="removeEvent(i)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
            <div class="li-ms-backdrop" *ngIf="openTimeDropdownIndex !== null" (click)="closeEventTimeDropdown()"></div>

            <p class="li-empty" *ngIf="!answers.events.length">No events added yet.</p>
          </ng-container>

          <!-- Q6: documents -->
          <ng-container *ngSwitchCase="'documents'">
            <div class="li-radio-row">
              <label class="li-radio">
                <input type="radio" name="q6" [checked]="answers.hasDocuments === true" (change)="answers.hasDocuments = true">
                <span class="li-radio-dot"></span> {{ currentQuestion.yesLabel }}
              </label>
              <label class="li-radio">
                <input type="radio" name="q6" [checked]="answers.hasDocuments === false" (change)="answers.hasDocuments = false">
                <span class="li-radio-dot"></span> {{ currentQuestion.noLabel }}
              </label>
            </div>

            <ng-container *ngIf="answers.hasDocuments">
              <!-- <div class="li-dropzone" (drop)="onDrop($event)" (dragover)="onDragOver($event)" (click)="fileInput.click()">
                <mat-icon>upload</mat-icon>
                <div class="li-dropzone-title">Drag &amp; drop files here</div>
                <div class="li-dropzone-sub">All file types supported</div>
                <input #fileInput type="file" multiple hidden (change)="onFilesSelected(fileInput.files); fileInput.value = ''">
              </div> -->
              <div class="li-doc-source-row">
                <div class="li-dropzone liDrag" (drop)="onDrop($event)" (dragover)="onDragOver($event)" (click)="fileInput.click()">
                  <mat-icon>upload</mat-icon>
                  <div class="li-dropzone-title">Drag &amp; drop files here</div>
                  <div class="li-dropzone-sub">All file types supported</div>
                  <input #fileInput type="file" multiple hidden (change)="onFilesSelected(fileInput.files); fileInput.value = ''">
                </div>
              
                <div class="li-doc-source-divider">OR</div>
              
              <button type="button" class="li-doc-library-btn" (click)="openDocumentLibrary()">
                <span class="li-doc-library-btn-icon">
                  <mat-icon>folder_open</mat-icon>
                </span>
                <div class="li-doc-library-btn-title">Add from Document Library</div>
                <div class="li-doc-library-btn-sub">Reuse a document you've already uploaded elsewhere</div>
              </button>
              </div>

              <div class="li-doc-entry" *ngFor="let doc of answers.documents; let i = index">
                <div class="li-doc-row">
                  <!-- Document Type (+ "Please specify" when Other is selected) share ONE
                       grid slot that internally splits in two, instead of adding a whole
                       new top-level column — so Document Name and the delete button never
                       shift position between "Other" and non-"Other" rows. -->
                  <div class="li-doc-type-cell" [class.has-other]="doc.documentType === 'Other'">
                    <div class="li-ms li-doc-type-ms" [class.open]="isDocTypeDropdownOpen(i)">
                      <label class="li-field-label">Document Type <span class="li-required">*</span></label>
                      <button type="button" class="li-ms-control" role="combobox"
                        [attr.aria-expanded]="isDocTypeDropdownOpen(i)" aria-haspopup="listbox"
                        (click)="toggleDocTypeDropdown(i, $event)">
                        <span class="li-ms-summary">{{ doc.documentType || 'Select type' }}</span>
                        <mat-icon class="li-ms-caret">expand_more</mat-icon>
                      </button>

                      <div class="li-ms-panel" [class.upward]="msOpenUpward" [ngStyle]="msPanelStyle" *ngIf="isDocTypeDropdownOpen(i)">
                        <ul class="li-ms-options" role="listbox">
                          <li class="li-ms-option" *ngFor="let opt of currentQuestion.options"
                            role="option" [attr.aria-selected]="doc.documentType === opt"
                            [class.selected]="doc.documentType === opt"
                            (click)="selectDocumentType(doc, opt)">
                            <span class="li-ms-radio-check" [class.checked]="doc.documentType === opt">
                              <mat-icon *ngIf="doc.documentType === opt">check</mat-icon>
                            </span>
                            <span class="li-ms-option-label">{{ opt }}</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div *ngIf="doc.documentType === 'Other'">
                      <!-- No visible "Please specify" label per design — the placeholder
                           text alone identifies the field. This invisible spacer preserves
                           the same label-height offset as the Document Type field above it,
                           so both inputs start on the same line (same pattern as
                           li-doc-delete-spacer below). -->
                      <label class="li-field-label li-doc-delete-spacer" aria-hidden="true">&nbsp;</label>
                      <!-- <input type="text" class="li-input" placeholder="Please specify..."
                        [ngModel]="doc.otherCategoryText" (ngModelChange)="setDocOtherCategoryText(doc, $event)" [appWordLimit]="50" aria-live="polite"> -->
                      
                      <input type="text" class="li-input" placeholder="Please specify..." [ngModel]="doc.otherCategoryText"
                          (ngModelChange)="setDocOtherCategoryText(doc, $event)"  [appWordLimit]="50"
                          aria-live="polite">

                      <div class="li-word-count" [class.li-required]="!isDocOtherValid(doc)">
                        {{ wordCount(doc.otherCategoryText || '') }}/50 words
                      </div>
                    </div>
                  </div>
                  <div>
                    <label class="li-field-label">Document Name</label>
                    <input type="text" class="li-input" [ngModel]="doc.documentName" (ngModelChange)="setDocumentName(doc, $event)" [appWordLimit]="50" aria-live="polite">
                    <div class="li-word-count" [class.li-required]="!isDocNameValid(doc)">
                      {{ wordCount(doc.documentName) }}/50 words
                    </div>
                  </div>

                  <!-- Invisible label-height spacer keeps the delete button's top edge
                       level with the input boxes (not the field labels) in every row. -->
                  <div>
                    <label class="li-field-label li-doc-delete-spacer" aria-hidden="true">&nbsp;</label>
                    <button class="li-icon-btn danger" (click)="removeDocument(i)" title="Remove">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </div>
                <div class="li-ms-backdrop" *ngIf="isDocTypeDropdownOpen(i)" (click)="closeDocTypeDropdown()"></div>

               
                <div class="li-doc-uploading-row" *ngIf="doc.uploading">
                  <mat-icon>hourglass_top</mat-icon>
                  <span>Uploading...</span>
                </div>

                <div class="li-doc-error-row" *ngIf="doc.uploadError">
                  <mat-icon>error_outline</mat-icon>
                  <span *ngIf="isDuplicateNameError(doc)">Document name already exists. Please enter a different name.</span>
                  <span *ngIf="!isDuplicateNameError(doc)">{{ doc.uploadError }}</span>
                  <button type="button" class="li-doc-retry-btn" *ngIf="!isDuplicateNameError(doc)" (click)="retryDocumentUpload(i)">Retry</button>
                </div>
              </div>
            </ng-container>

            <!-- Q6: Document Library picker -->
            <div class="li-doc-lib-overlay" *ngIf="docLibraryOpen" (click)="closeDocumentLibrary()">
              <div class="li-doc-lib-panel" (click)="$event.stopPropagation()">
                <div class="li-doc-lib-header">
                  <span>Document Library</span>
                  <button class="li-close" (click)="closeDocumentLibrary()" aria-label="Close">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
            
                <div class="li-doc-lib-search">
                  <mat-icon>search</mat-icon>
                  <input type="text" [(ngModel)]="docLibrarySearch" placeholder="Search your documents...">
                </div>
            
                <div class="li-doc-lib-loading" *ngIf="docLibraryLoading">
                  <mat-spinner diameter="28"></mat-spinner>
                </div>
            
                <ul class="li-doc-lib-list" *ngIf="!docLibraryLoading">
                  <li class="li-doc-lib-item" *ngFor="let d of filteredLibraryDocs()" [class.selected]="isLibrarySelected(d.id)"
                    [class.disabled]="isAlreadyAdded(d.id)" (click)="!isAlreadyAdded(d.id) && toggleLibrarySelection(d.id)">
                    <span class="li-ms-checkbox" [class.checked]="isLibrarySelected(d.id)">
                      <mat-icon *ngIf="isLibrarySelected(d.id)">check</mat-icon>
                    </span>
                    <mat-icon class="li-doc-lib-file-icon">description</mat-icon>
                    <div class="li-doc-lib-item-meta">
                      <div class="li-doc-lib-item-name">{{ d.name }}</div>
                    </div>
                    <span class="li-doc-lib-added-badge" *ngIf="isAlreadyAdded(d.id)">Already added</span>
                  </li>
                  <li class="li-doc-lib-empty" *ngIf="!filteredLibraryDocs().length">No documents found</li>
                </ul>
            
                <div class="li-doc-lib-footer">
                  <span>{{ librarySelection.size }} selected</span>
                  <button class="li-btn-primary" [disabled]="!librarySelection.size" (click)="addSelectedFromLibrary()">
                    Add {{ librarySelection.size || '' }} Document{{ librarySelection.size === 1 ? '' : 's' }}
                  </button>
                </div>
              </div>
            </div>

          </ng-container>

        </ng-container>

        <!-- Reusable searchable multi-select autocomplete (Q2, Q7, Q8) — PRD §15/16 -->
        <ng-template #chipsPicker>
          <label class="li-field-label" *ngIf="currentQuestion.optionsFieldLabel">{{ currentQuestion.optionsFieldLabel }}</label>

       
          <div class="li-ms-other-row">
            <div class="li-ms" [class.open]="isDropdownOpen(currentQuestion.step)">
              <button type="button" class="li-ms-control" role="combobox"
                [attr.aria-expanded]="isDropdownOpen(currentQuestion.step)" aria-haspopup="listbox"
                (click)="toggleDropdown(currentQuestion.step, $event)">
                <span class="li-ms-placeholder" *ngIf="!selectedOptions(currentQuestion).length">Search and select&hellip;</span>
                <span class="li-ms-summary" *ngIf="selectedOptions(currentQuestion).length">
                  {{ selectedOptions(currentQuestion).length }} selected
                </span>
                <mat-icon class="li-ms-caret">expand_more</mat-icon>
              </button>

              <div class="li-ms-panel" [class.upward]="msOpenUpward" [ngStyle]="msPanelStyle" *ngIf="isDropdownOpen(currentQuestion.step)">
                <div class="li-ms-search">
                  <mat-icon>search</mat-icon>
                  <input type="text" [ngModel]="getDropdownSearch(currentQuestion.step)"
                    (ngModelChange)="setDropdownSearch(currentQuestion.step, $event)"
                    (keydown.escape)="closeDropdown()"
                    placeholder="Type to search..." autocomplete="off" aria-label="Search options">
                </div>
                <ul class="li-ms-options" role="listbox" aria-multiselectable="true">
                  <li class="li-ms-option" *ngFor="let opt of filteredDropdownOptions(currentQuestion)"
                    role="option" [attr.aria-selected]="isOptionSelected(currentQuestion, opt)"
                    [class.selected]="isOptionSelected(currentQuestion, opt)"
                    (click)="toggleOption(currentQuestion, opt)">
                    <span class="li-ms-checkbox" [class.checked]="isOptionSelected(currentQuestion, opt)">
                      <mat-icon *ngIf="isOptionSelected(currentQuestion, opt)">check</mat-icon>
                    </span>
                    <span class="li-ms-option-label">{{ opt }}</span>
                  </li>
                  <li class="li-ms-empty" *ngIf="!filteredDropdownOptions(currentQuestion).length">No matches found</li>
                </ul>
              </div>
            </div>

            <!-- "Please specify" free text (PRD §16 "Other" 50-word field) — only once "Other" is selected. -->
            <div class="li-ms-other-field" *ngIf="isOtherSelected(currentQuestion)">
              <!-- <label class="li-field-label">Please specify <span class="li-required">*</span></label> -->
              <input type="text" class="li-input" placeholder="Please specify..."
                [ngModel]="otherText(currentQuestion)" (ngModelChange)="setOtherText(currentQuestion, $event)" [appWordLimit]="currentQuestion.wordLimit ?? 50" aria-live="polite">
              <div class="li-word-count" [class.li-required]="!otherText(currentQuestion).trim() || !isOtherTextValid(currentQuestion)">
                {{ wordCount(otherText(currentQuestion)) }}/{{ currentQuestion.wordLimit }} words
              </div>
            </div>
          </div>
          <div class="li-ms-backdrop" *ngIf="isDropdownOpen(currentQuestion.step)" (click)="closeDropdown()"></div>

          <div class="li-chip-list">
            <span class="li-chip" *ngFor="let opt of selectedOptions(currentQuestion)">
              {{ opt }}
              <button type="button" (click)="removeOption(currentQuestion, opt)" [attr.aria-label]="'Remove ' + opt">&times;</button>
            </span>
          </div>
        </ng-template>
      </div>

      <div class="li-footer">
        <button class="li-btn-outline" *ngIf="currentStepIndex === 0" (click)="cancel()">Cancel</button>
        <button class="li-btn-outline" *ngIf="currentStepIndex > 0" (click)="previous()">Previous</button>
       <button class="li-btn-outline-filled" (click)="saveForLater()" [disabled]="saveForLaterDisabled" [matTooltip]="nextDisabledReason" [matTooltipDisabled]="saving || uploading || !nextDisabledReason"
          matTooltipPosition="above">Save for later</button>
        <button class="li-btn-primary" (click)="next()" [disabled]="saving || uploading || !isStepValid(currentQuestion)"
          [matTooltip]="nextDisabledReason" [matTooltipDisabled]="saving || uploading || !nextDisabledReason"
          matTooltipPosition="above"
          [attr.aria-disabled]="saving || uploading || !isStepValid(currentQuestion)">
          {{ currentStepIndex === totalSteps - 1 ? 'Review' : 'Save & Next' }} <mat-icon>arrow_forward</mat-icon>
        </button>
      </div>
    </ng-container>

    <!-- ===================== REVIEW ===================== -->
    <ng-container *ngIf="mode === 'review'">
      <div class="li-header">
        <div>
          <div class="li-step-label">REVIEW</div>
          <div class="li-title">Review Legal Information</div>
          <!-- <p class="li-review-subtitle">Please review all the details before saving.</p> -->
        </div>
        <button class="li-close" (click)="cancel()" aria-label="Close">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="li-body li-review2-body">
        <div class="li-review2-grid">

          <!-- LEFT COLUMN -->
          <div class="li-review2-col">

            <div class="li-review2-card">
              <div class="li-review2-card-head">
                <span class="li-review2-icon"><mat-icon>description</mat-icon></span>
                <span class="li-review2-label">Case Title</span>
                <button class="li-edit-btn" title="Edit case title" (click)="editSection(1)"><mat-icon>edit</mat-icon> Edit</button>
              </div>
              <div class="li-review2-value" [class.italic]="!answers.caseTitle">{{ answers.caseTitle || 'Not provided' }}</div>
            </div>

            <div class="li-review2-card">
              <div class="li-review2-card-head">
                <span class="li-review2-icon"><mat-icon>category</mat-icon></span>
                <span class="li-review2-label">Issue Type</span>
                <button class="li-edit-btn" title="Edit issue type" (click)="editSection(2)"><mat-icon>edit</mat-icon> Edit</button>
              </div>
              <div class="li-chip-list li-review2-chips" *ngIf="answers.issueTypes.length; else review2NoneLeft">
                <span class="li-chip static" *ngFor="let t of answers.issueTypes">{{ t }}</span>
              </div>
            </div>

            <div class="li-review2-card">
              <div class="li-review2-card-head">
                <span class="li-review2-icon"><mat-icon>groups</mat-icon></span>
                <span class="li-review2-label">Opposing Parties</span>
                <button class="li-edit-btn" title="Edit opposing parties" (click)="editSection(3)"><mat-icon>edit</mat-icon> Edit</button>
              </div>
              <ng-container *ngIf="answers.opposingParties.length; else review2NoneLeft">
                <div class="li-review2-stacked-name" *ngFor="let p of answers.opposingParties">{{ p.name }}</div>
              </ng-container>
            </div>

            <div class="li-review2-card">
              <div class="li-review2-card-head">
                <span class="li-review2-icon"><mat-icon>flag</mat-icon></span>
                <span class="li-review2-label">Expected Outcome</span>
                <button class="li-edit-btn" title="Edit expected outcome" (click)="editSection(7)"><mat-icon>edit</mat-icon> Edit</button>
              </div>
              <ul class="li-review2-bullets" *ngIf="answers.expectedOutcomes.length; else review2NoneLeft">
                <li *ngFor="let o of answers.expectedOutcomes">{{ o }}</li>
              </ul>
            </div>

            <div class="li-review2-card no-border">
              <div class="li-review2-card-head">
                <span class="li-review2-icon"><mat-icon>gavel</mat-icon></span>
                <span class="li-review2-label">Legal Action Taken</span>
                <button class="li-edit-btn" title="Edit legal action taken" (click)="editSection(8)"><mat-icon>edit</mat-icon> Edit</button>
              </div>
              <ul class="li-review2-bullets" *ngIf="answers.legalActions.length; else review2NoneLeft">
                <li *ngFor="let a of answers.legalActions">{{ a }}</li>
              </ul>
            </div>

            <ng-template #review2NoneLeft>
              <div class="li-review2-value italic">Not provided</div>
            </ng-template>
          </div>

          <!-- RIGHT COLUMN -->
          <div class="li-review2-col">

            <div class="li-review2-card">
              <div class="li-review2-card-head">
                <span class="li-review2-icon"><mat-icon>article</mat-icon></span>
                <span class="li-review2-label">Incident Description</span>
                <button class="li-edit-btn" title="Edit incident description" (click)="editSection(4)"><mat-icon>edit</mat-icon> Edit</button>
              </div>
              <div class="li-review2-value" [class.italic]="!answers.incidentDescription">
                <ng-container *ngIf="answers.incidentDescription; else review2NoneRight">
                  {{ isReviewExpanded('incident') ? answers.incidentDescription : reviewTextPreview(answers.incidentDescription) }}
                  <button class="li-review2-readmore" type="button" *ngIf="isReviewTextLong(answers.incidentDescription)"
                    (click)="toggleReviewExpanded('incident')">
                    {{ isReviewExpanded('incident') ? 'Read less' : 'Read more' }}
                  </button>
                </ng-container>
              </div>
            </div>

            <div class="li-review2-card">
              <div class="li-review2-card-head">
                <span class="li-review2-icon"><mat-icon>event</mat-icon></span>
                <span class="li-review2-label">Events</span>
                <button class="li-edit-btn" title="Edit events" (click)="editSection(5)"><mat-icon>edit</mat-icon> Edit</button>
              </div>
              <ul class="li-review2-bullets" *ngIf="answers.events.length; else review2NoneRight">
                <li *ngFor="let e of reviewVisibleEvents()">{{ reviewFormatDate(e.date) }} — {{ e.event }}<span *ngIf="e.location"> ({{ e.location }})</span></li>
              </ul>
              <button class="li-review2-more" type="button" *ngIf="reviewExtraEventsCount() > 0" (click)="editSection(5)">
                + {{ reviewExtraEventsCount() }} more event{{ reviewExtraEventsCount() > 1 ? 's' : '' }}
              </button>
            </div>

            <div class="li-review2-card">
              <div class="li-review2-card-head">
                <span class="li-review2-icon"><mat-icon>folder</mat-icon></span>
                <span class="li-review2-label">Supporting Documents</span>
                <button class="li-edit-btn" title="Edit supporting documents" (click)="editSection(6)"><mat-icon>edit</mat-icon> Edit</button>
              </div>
              <ng-container *ngIf="answers.documents.length; else review2NoneRight">
                <div class="li-review2-doc-count">{{ answers.documents.length }} Document{{ answers.documents.length > 1 ? 's' : '' }} uploaded</div>
                <ul class="li-review2-bullets plain">
                  <li *ngFor="let d of reviewVisibleDocuments()">{{ d.documentName }}</li>
                </ul>
                <!-- <button class="li-review2-more" type="button" *ngIf="reviewExtraDocumentsCount() > 0" (click)="editSection(6)">
                  + {{ reviewExtraDocumentsCount() }} more document{{ reviewExtraDocumentsCount() > 1 ? 's' : '' }}
                </button> -->
                <button class="li-review2-more" type="button" *ngIf="reviewExtraDocumentsCount() > 0"
                  [attr.aria-expanded]="isReviewExpanded('documents')" (click)="toggleReviewExpanded('documents')">
                  {{ isReviewExpanded('documents')
                  ? 'Show less' : '+ ' + reviewExtraDocumentsCount() + ' more document' + (reviewExtraDocumentsCount() > 1 ? 's' : '') }}
              </button>
              </ng-container>
            </div>

            <div class="li-review2-card">
              <div class="li-review2-card-head">
                <span class="li-review2-icon"><mat-icon>schedule</mat-icon></span>
                <span class="li-review2-label">Deadlines</span>
                <button class="li-edit-btn" title="Edit deadlines" (click)="editSection(9)"><mat-icon>edit</mat-icon> Edit</button>
              </div>
              <ul class="li-review2-bullets plain" *ngIf="answers.deadlines.length; else review2NoneRight">
                <li *ngFor="let d of answers.deadlines">{{ reviewDeadlineLabel(d) }}</li>
              </ul>
            </div>

            <div class="li-review2-card no-border">
              <div class="li-review2-card-head">
                <span class="li-review2-icon"><mat-icon>info</mat-icon></span>
                <span class="li-review2-label">Additional Information</span>
                <button class="li-edit-btn" title="Edit additional information" (click)="editSection(10)"><mat-icon>edit</mat-icon> Edit</button>
              </div>
              <div class="li-review2-value" [class.italic]="!answers.additionalInformation">
                <ng-container *ngIf="answers.additionalInformation; else review2NoneRight">
                  {{ isReviewExpanded('additional') ? answers.additionalInformation : reviewTextPreview(answers.additionalInformation) }}
                  <button class="li-review2-readmore" type="button" *ngIf="isReviewTextLong(answers.additionalInformation)"
                    (click)="toggleReviewExpanded('additional')">
                    {{ isReviewExpanded('additional') ? 'Read less' : 'Read more' }}
                  </button>
                </ng-container>
              </div>
            </div>

            <ng-template #review2NoneRight>
              <div class="li-review2-value italic">Not provided</div>
            </ng-template>
          </div>

        </div>
      </div>

      <div class="li-footer">
        <button class="li-btn-outline" (click)="cancel()">Cancel</button>
        <button class="li-btn-primary" (click)="submit()" [disabled]="submitting">
          <mat-icon>save</mat-icon> {{ submitting ? 'Saving...' : 'Save Legal Information' }}
        </button>
      </div>
    </ng-container>

    <!-- ===================== SUCCESS ===================== -->
    <ng-container *ngIf="mode === 'success'">
      <div class="li-success">
        <div class="li-success-icon"><mat-icon>check</mat-icon></div>
        <!-- <div class="li-success-badge">Completed</div> -->
        <h2 class="li-success-title">Legal Information Saved Successfully</h2>
        <p class="li-success-desc">
          Your legal information has been securely saved. You can continue editing it anytime or share it with your lawyer later.
        </p>
        <div class="li-success-actions">
          <button class="li-btn-outline" (click)="backToList()">Back to List</button>
          <button class="li-btn-primary" *ngIf="legalInfoStatus === 'completed'" (click)="shareWithLawyer()">Share With Lawyer</button>
        </div>
      </div>
    </ng-container>

  </ng-container>
</div>